export const config = {
    animation: true,
    appearance: true,
    backgroundAttachment: true,
    boxSizing: true,
    cursor: true,
    float: true,
    listStyleType: true,
    listStylePosition: true,
    listStyleImage: true,
    objectFit: true,
    objectPosition: true,
    outline: true,
    overflowX: true,
    overflowY: true,
    overflowWrap: true,
    pointerEvents: true,
    resize: true,
    textDecoration: true,
    textOverflow: true,
    textTransform: true,
    transform: true,
    transformOrigin: true,
    transition: true,
    userSelect: true,
    visibility: true,
    whiteSpace: true,
    willChange: true,
    wordBreak: true,
};
